<!--

    Copyright (C) 2025 Das Land Schleswig-Holstein vertreten durch den
    Ministerpräsidenten des Landes Schleswig-Holstein
    Staatskanzlei
    Abteilung Digitalisierung und zentrales IT-Management der Landesregierung

    Lizenziert unter der EUPL, Version 1.2 oder - sobald
    diese von der Europäischen Kommission genehmigt wurden -
    Folgeversionen der EUPL ("Lizenz");
    Sie dürfen dieses Werk ausschließlich gemäß
    dieser Lizenz nutzen.
    Eine Kopie der Lizenz finden Sie hier:

    https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12

    Sofern nicht durch anwendbare Rechtsvorschriften
    gefordert oder in schriftlicher Form vereinbart, wird
    die unter der Lizenz verbreitete Software "so wie sie
    ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
    ausdrücklich oder stillschweigend - verbreitet.
    Die sprachspezifischen Genehmigungen und Beschränkungen
    unter der Lizenz sind dem Lizenztext zu entnehmen.

-->
@if (organisationEinheitResource) {
  <div class="flex items-center gap-8" data-test-id="organisation-einheit-edit">
    <div>
      <p>{{ organisationEinheitResource.name }}</p>
      <p>
        {{ organisationEinheitResource.anschrift.strasse }} {{ organisationEinheitResource.anschrift.hausnummer }},
        {{ organisationEinheitResource.anschrift.plz }} {{ organisationEinheitResource.anschrift.ort }}
      </p>
    </div>
    <ods-button size="fit" (clicked)="openSearchDialog()" data-test-id="organisation-einheit-edit-button">
      <ods-icon icon name="edit" size="small" fill="whitetext" />
    </ods-button>
  </div>
} @else {
  <ods-button
    text="Organisationseinheit zuweisen"
    (clicked)="openSearchDialog()"
    data-test-id="organisation-einheit-search-button"
  />
}
